import React from 'react';
import ReactMarkdown from 'react-markdown';
import { Box, Typography } from '@mui/material';

interface MarkdownContentProps {
  content: string;
}

const MarkdownContent: React.FC<MarkdownContentProps> = ({ content }) => {
  // Components for custom rendering of Markdown elements
  const components = {
    h1: (props: any) => <Typography variant="h3" component="h1" color="white" gutterBottom {...props} />,
    h2: (props: any) => <Typography variant="h4" component="h2" color="white" gutterBottom {...props} />,
    h3: (props: any) => <Typography variant="h5" component="h3" color="white" gutterBottom {...props} />,
    h4: (props: any) => <Typography variant="h6" component="h4" color="white" gutterBottom {...props} />,
    h5: (props: any) => <Typography variant="subtitle1" component="h5" color="white" gutterBottom {...props} />,
    h6: (props: any) => <Typography variant="subtitle2" component="h6" color="white" gutterBottom {...props} />,
    p: (props: any) => <Typography variant="body1" color="white" paragraph {...props} />,
    // Custom list styling
    ul: (props: any) => <Box component="ul" sx={{ color: 'white', pl: 4, mb: 2 }} {...props} />,
    ol: (props: any) => <Box component="ol" sx={{ color: 'white', pl: 4, mb: 2 }} {...props} />,
    li: (props: any) => <Box component="li" sx={{ color: 'white', mb: 1 }} {...props} />,
    // Code blocks with better contrast
    code: (props: any) => (
      <Box 
        component="code" 
        sx={{ 
          backgroundColor: 'rgba(0, 0, 0, 0.3)', 
          color: '#90caf9', 
          p: 0.5, 
          borderRadius: 1, 
          fontFamily: 'monospace' 
        }} 
        {...props} 
      />
    ),
    // Code blocks (pre)
    pre: (props: any) => (
      <Box 
        component="pre" 
        sx={{ 
          backgroundColor: 'rgba(0, 0, 0, 0.3)', 
          color: '#90caf9', 
          p: 2, 
          borderRadius: 1, 
          overflow: 'auto',
          fontFamily: 'monospace',
          mb: 2
        }} 
        {...props} 
      />
    ),
    // Block quotes
    blockquote: (props: any) => (
      <Box 
        component="blockquote" 
        sx={{ 
          borderLeft: '4px solid',
          borderColor: 'primary.main',
          pl: 2,
          py: 1,
          my: 2,
          bgcolor: 'rgba(255, 255, 255, 0.1)',
          borderRadius: 1,
          color: 'white'
        }} 
        {...props} 
      />
    ),
    // Horizontal rule
    hr: () => <Box component="hr" sx={{ my: 3, borderColor: 'rgba(255, 255, 255, 0.2)' }} />,
    // Links
    a: (props: any) => (
      <Box 
        component="a" 
        sx={{ 
          color: '#90caf9',
          textDecoration: 'none',
          '&:hover': {
            textDecoration: 'underline'
          }
        }} 
        {...props} 
      />
    ),
  };

  return (
    <Box className="markdown-content" sx={{ color: 'white' }}>
      <ReactMarkdown components={components}>
        {content}
      </ReactMarkdown>
    </Box>
  );
};

export default MarkdownContent; 